import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AdminAccessPageRBAC = {
  pageID: 'aa8b5bf8670923672d78eb97e22ca7d1',
  elementID: {
    ViewList: '89e3f75dc700a224f72423a74fff43a3',
    AddNewPage: '007c72939d3ffdd6ec100eee2577f671',
  },
} as const

export const useRBACAdminAccessPagePage = createUseRBAC(AdminAccessPageRBAC.elementID)

export type UseRBACAdminAccessPagePageType = ReturnType<typeof useRBACAdminAccessPagePage>

export const VendorAccessPageRBAC = {
  pageID: 'bfd47ad9bab5c69ddcc64acb48dca7c8',
  elementID: {
    ViewList: '58b98b8d2791de8d5e6a184451c1424c',
    AddNewPage: 'd4f93b3a97483a6f009ba74c3237bb0b',
    ExportPageDetail: 'd774f820bee746ad56de2730e60023d4',
  },
} as const
export const useRBACVendorAccessPagePage = createUseRBAC(VendorAccessPageRBAC.elementID)
export type UseRBACVendorAccessPagePageType = ReturnType<typeof useRBACVendorAccessPagePage>
